import axios from 'axios';
import router from '../../router/router';

const state = { 
}
const mutations = { 
}
const getters = { 
}
const actions = {

  addWebTab({
    rootState
  }, opt) { // 自定义底部菜单
    return new Promise((resolve, reject) => {
      axios.post(`${rootState.api.api}/api/v3/webtab`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        resolve(err);
        console.log(err);
      });
    });
  },
  putWebTab({
    rootState
  }, opt) { // 自定义底部菜单
    return new Promise((resolve, reject) => {
      axios.patch(`${rootState.api.api}/api/v3/webtab?id=${opt.id}`, opt.opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getWebTab({
    rootState
  }, opt) { // 获取自定义底部菜单
    return new Promise((resolve, reject) => {
      axios.post(`${rootState.api.api}/api/v3/webtab/query`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}